import { default as NextImage } from 'next/image'
import classNames from 'classnames'

import { ImageProps } from './Image.schema'

const Image = (props: ImageProps): JSX.Element => {
    const className = classNames('image', props.className)

    return (
        <NextImage
            className={className}
            width={props.width || undefined}
            height={props.height || undefined}
            sizes={props.sizes}
            priority={props.priority}
            loading={props.priority ? 'eager' : 'lazy'}
            style={props.style}
            fill={props.fill}
            src={props.url}
            alt={props.alternativeText || 'Image alternative text'}
        />
    )
}

export default Image

